import React from 'react';
import '../../styles/pages.css';

type Props = {
  onReset?: () => void;
};

export default function ErrorPage({ onReset }: Props) {
  return (
    <div className="notFoundShell">
      <div className="notFoundShell__card errorPage__card">

        {/* Icon */}
        <div className="errorPage__iconWrap">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              stroke="#0057A4"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Badge */}
        <div className="notFoundShell__badge errorPage__badge">Unexpected error</div>

        {/* Title */}
        <h1 className="notFoundShell__title">Something went wrong</h1>

        {/* Message */}
        <p className="notFoundShell__text">
          An unexpected error occurred in the application. Your data is safe — this is likely a
          temporary issue. Try refreshing the page or returning to your dashboard.
        </p>

        {/* Actions */}
        <div className="notFoundShell__actions">
          <button
            className="errorPage__primaryBtn"
            onClick={() => { window.location.href = '/dashboard'; }}
          >
            Back to dashboard
          </button>
          <button
            className="errorPage__secondaryBtn"
            onClick={() => {
              if (onReset) onReset();
              else window.location.reload();
            }}
          >
            Reload page
          </button>
        </div>

      </div>
    </div>
  );
}
